import $ from "jquery";

export const SLIDER_MODE_VERTICAL = 0;
export const SLIDER_MODE_HORIZONTAL = 1;

$.fn.makeSlider = function(options = {}) {
    const DEFAULT_OPTIONS = {
        mode: SLIDER_MODE_HORIZONTAL,
        onStartDrag: () => {},
        onSeek: () => {},
        onDragEnd: () => {},
        sliderSelector: ".progress_bar",
        handlerSelector: ".progress_handler"
    };

    options = Object.assign({}, DEFAULT_OPTIONS, options);

    function extractOffsetFromEvent(e, $sliderWrapper) {
        let offset = (options.mode === SLIDER_MODE_HORIZONTAL ? e.offsetX : e.offsetY);
        if ($(e.target).is(options.handlerSelector)) {
            offset += SLIDER_MODE_HORIZONTAL ? $(e.target).position().left : $(e.target).position().top;
        } else if ($(e.target).is( $sliderWrapper )) {
            offset -= $sliderWrapper.find(options.sliderSelector).position().left;
        }
        return offset;
    }

    this.each((i, e) => {
        const $sliderWrapper = $(e);
        // $sliderBar = $sliderWrapper.find(options.sliderSelector),
        let dragging = false;

        $sliderWrapper.find(options.handlerSelector).on("mousedown", () => {
            dragging = true;
            options.onStartDrag();
        });

        $sliderWrapper.on("mousemove", (e) => {
            if (dragging) {
                let sliderMax = options.mode === SLIDER_MODE_HORIZONTAL ?  $sliderWrapper.width() : $sliderWrapper.height();
                let offset = extractOffsetFromEvent(e, $sliderWrapper);
                options.onSeek(offset / sliderMax * 100);
            }
        });

        $sliderWrapper.on("mouseup", (e) => {
            if (!dragging) {
                let sliderMax = options.mode === SLIDER_MODE_HORIZONTAL ?  $sliderWrapper.width() : $sliderWrapper.height();
                let offset = extractOffsetFromEvent(e, $sliderWrapper);
                options.onSeek(offset / sliderMax * 100);
            }
            else {
                dragging = false;
                options.onDragEnd();
            }
        });
    });
};

